import { NgModule } from '@angular/core';

import { VideoProjectComponent } from './video-project.component';
import { VideoProjectFormService } from './video-project.form';
import { VideoProjectService } from './video-project.service';

@NgModule({
  imports: [VideoProjectComponent],
  providers: [VideoProjectService, VideoProjectFormService],
  exports: [VideoProjectComponent],
})
export class VideoProjectModule {}
